<template>
  <Intros :listTitle="listTitle" :content="content"/>
</template>

<script>
export default {
  data () {
    return {
      listTitle: '企业简介',
      content: '<div style="font-size:16px;text-indent:2em;">数力拓新仿真技术（北京）有限公司是一家从事计算技术和仿真技术研发及服务的新型科技企业。公司成立于2013年，落户于北京市上地高科技产业园区。公司专注于企业数字计算和工程数值计算，致力于企业信息化及信息处理，通过各类新型仿真技术和信息技术的运用，助力企业调整构架、整合资源、严密组织、有力控制、安全生产、承担企业社会责任。我们坚信：数字有力量，仿真开拓新世界。公司掌握核心计算技术和仿真技术，提供相关技术开发、技术转让、技术服务、咨询培训、软硬件开发及销售等业务，特别提供各种个性化软件及技术定制服务。技术应用涉及众多行业，如水利水电、岩土工程、土木建筑、科研教育、航空航天、装备制造、电气电子、航洋工程、石油化工、汽车及电力行业等。</div><br /><br /><img src="../intros/dpihome.png" style="width:600px;height:300px;margin:10px 100px;">'
    }
  }
}
</script>
